import React from 'react';
import { translate } from 'react-translate';
import SelectOnTab from '../../../../components/SelectOnTab/SelectOnTab';

const FilterRole = ({ t, onChange, disabled, role }) => {
  const values = [
    {
      status: 'all',
      preset: 'all',
      label: t('ROLE'),
    },
    {
      status: 'admin',
      preset: 'admin',
      label: t('ADMIN'),
    },
    {
      status: 'emloyee',
      preset: 'default_user',
      label: t('EMPLOYEE'),
    },
  ];

  return (
    <SelectOnTab
      iconSelect={['far', 'user']}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      selectValue={role}
    >
      {values.map((value, index) => (
        <option key={index} value={`${value.preset}`}>
          {value.label}
        </option>
      ))}
    </SelectOnTab>
  );
};

export default translate('User')(FilterRole);
